export function getDashboardToken() {
  const { pathname } = window.location;
  const pathnameSplited = pathname.split('/');
  const tokenIdx = pathnameSplited.indexOf('dashboard') + 1;
  const token = pathnameSplited[tokenIdx];

  return token || '';
}
